/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Tabs } from './Tabs';
import {
    TabsFromJSON,
    TabsFromJSONTyped,
    TabsToJSON,
} from './Tabs';

/**
 * 
 * @export
 * @interface Signer
 */
export interface Signer {
    /**
     * The email address of the signer
     * @type {string}
     * @memberof Signer
     */
    email: string;
    /**
     * The full name of the signer
     * @type {string}
     * @memberof Signer
     */
    name: string;
    /**
     * The recipient ID of the signer
     * @type {string}
     * @memberof Signer
     */
    recipientId: string;
    /**
     * Specifies the signer’s routing order. Lower values are processed earlier. Parallel routing can be achieved by assigning the same order to multiple recipients
     * @type {number}
     * @memberof Signer
     */
    routingOrder: number;
    /**
     * The list of tabs for the signer
     * @type {Array<Tabs>}
     * @memberof Signer
     */
    tabs: Array<Tabs>;
}

/**
 * Check if a given object implements the Signer interface.
 */
export function instanceOfSigner(value: object): boolean {
    if (!('email' in value)) return false;
    if (!('name' in value)) return false;
    if (!('recipientId' in value)) return false;
    if (!('routingOrder' in value)) return false;
    if (!('tabs' in value)) return false;
    return true;
}

export function SignerFromJSON(json: any): Signer {
    return SignerFromJSONTyped(json, false);
}

export function SignerFromJSONTyped(json: any, ignoreDiscriminator: boolean): Signer {
    if (json == null) {
        return json;
    }
    return {
        
        'email': json['email'],
        'name': json['name'],
        'recipientId': json['recipientId'],
        'routingOrder': json['routingOrder'],
        'tabs': ((json['tabs'] as Array<any>).map(TabsFromJSON)),
    };
}

export function SignerToJSON(value?: Signer | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'email': value['email'],
        'name': value['name'],
        'recipientId': value['recipientId'],
        'routingOrder': value['routingOrder'],
        'tabs': ((value['tabs'] as Array<any>).map(TabsToJSON)),
    };
}

